import { render, staticRenderFns } from "./GlobalAudio.vue?vue&type=template&id=09a81ce5&scoped=true&"
import script from "./GlobalAudio.vue?vue&type=script&lang=js&"
export * from "./GlobalAudio.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/GlobalAudio/GlobalAudio.less?vue&type=style&index=0&id=09a81ce5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a81ce5",
  null
  
)

export default component.exports